const truncateString = (input: string, length: number) =>
  input.length > length ? `${input.substring(0, length)}...` : input

export default truncateString
